import { render } from "./TelegramAuth.vue?vue&type=template&id=195a80a5"
import script from "./TelegramAuth.vue?vue&type=script&lang=js"
export * from "./TelegramAuth.vue?vue&type=script&lang=js"

import "./TelegramAuth.vue?vue&type=style&index=0&id=195a80a5&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__